import React, { CSSProperties } from "react";
import { Tag } from "antd";
import { radius } from "@libertify/ui";

export type StatusTagProps = {
  icon: React.ReactNode;
  color: string;
  label: React.ReactNode;
  style?: CSSProperties;
};

const baseStyle: CSSProperties = {
  border: 0,
  borderRadius: radius.pill,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const StatusTag: React.FC<StatusTagProps> = ({ icon, color, label, style }) => (
  <Tag color={color} icon={icon} style={{ ...baseStyle, ...style }}>
    {label}
  </Tag>
);

export default StatusTag;
